// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.log-out {
  display: flex;
  align-items: center;
  width: 100px;
  height: 100px;
}

.log-out a {
  background-color: #333;
  color: #fff;
  border-radius: 5px;
  padding: 10px;
  margin-right: 10px;
  font-size: 1.5rem;
  font-weight: bold;
  text-decoration: none;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;AACJ;;AAEE;EACE,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;AACJ","sourcesContent":[".log-out {\n    display: flex;\n    align-items: center;\n    width: 100px;\n    height: 100px;\n  }\n  \n  .log-out a {\n    background-color: #333;\n    color: #fff;\n    border-radius: 5px;\n    padding: 10px;\n    margin-right: 10px;\n    font-size: 1.5rem;\n    font-weight: bold;\n    text-decoration: none;\n    cursor: pointer;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
